<template>
    <section class="live-header-info">
        <div class="header-video-info">
            <img class="header-avater"
                 :src="avatar"
                 alt="直播员头像">
            <div class="header-video-txt">
                <div class="header-video-name">
                    <span>{{username}}</span><em class="tips"></em>
                </div>
                <div class="header-video-time">{{startTime}} 至 {{endTime}}</div>
            </div>
            <Like :name="'liked:video:' + id"></Like>
        </div>
        <div class="header-video-title">
            <p>{{title}}</p>
            <div class="header-video-description"
                 v-if="description"
                 :class="[isCollapseHide ?'down':'up']"
                 @click="collapseEvents">
                <p>
                    <i class="el-icon-caret-bottom"
                       v-if="isCollapseHide"></i>
                    {{description}}
                    <i class="el-icon-caret-top"
                       v-if="!isCollapseHide"></i>
                </p>
            </div>
        </div>
        <!-- <div class="live-tag-group"
             v-if="tags.length">
            <div class="live-tag"
                 :key="index"
                 v-for="(item, index) in tags">{{item}}</div>
        </div> -->
        <div class="video-location">
            <div class="video-addr">{{address}}</div>
        </div>
    </section>
</template>

<script>
import Like from "./like"
import jsonp from 'jsonp';

export default {
    data () {
        return {
            isCollapseHide: true
        }
    },
    components: {
        Like
    },
    props: {
        id: Number,
        avatar: String,
        title: String,
        description: String,
        username: String,
        startTime: String,
        endTime: String,
        address: String,
        tags: Array,
        liveUrl: String
    },
    methods: {
        collapseEvents () {
            this.isCollapseHide = !this.isCollapseHide
        },
        getStatistPv () {
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=${encodeURIComponent(this.liveUrl)}&tag=zgapp-live&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })
        }
    },
    created () {
        this.getStatistPv();    //PV统计   
    }
}
</script>

<style scoped>
.header-video-description {
    font-size: 0.3rem;
    line-height: 0.5rem;
    color: #acacac;
    margin-top: 0.3rem;
}
.header-video-description.down p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.header-video-description i {
    float: right;
    font-size: 0.5rem;
    vertical-align: middle;
}
</style>
